import Navbar from "../../components/public/Navbar";
import Footer from "../../components/public/Footer";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-testid="privacy-page">
        <p className="eyebrow mb-3">Privacy</p>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold text-brand-charcoal mb-8">Privacybeleid</h1>
        <div className="space-y-6 text-brand-charcoal/80 leading-relaxed text-[15px]">
          <p>Nails Renss hecht veel belang aan de bescherming van jouw persoonsgegevens. In dit privacybeleid leggen we uit welke gegevens we verzamelen, waarom en hoe we ermee omgaan.</p>

          <div>
            <h2 className="font-display text-2xl font-medium text-brand-charcoal mb-2">Welke gegevens verzamelen we?</h2>
            <p>Wanneer je online een afspraak boekt, vragen we je voornaam, achternaam, e-mailadres en telefoonnummer. Een optionele notitie kan je zelf toevoegen. Deze gegevens zijn nodig om je afspraak te bevestigen en je te kunnen contacteren.</p>
          </div>

          <div>
            <h2 className="font-display text-2xl font-medium text-brand-charcoal mb-2">Waarom verzamelen we deze gegevens?</h2>
            <p>We gebruiken je gegevens uitsluitend om je afspraak te beheren, je een bevestiging te sturen en je indien nodig te contacteren over je afspraak. We gebruiken je gegevens niet voor marketing en delen ze niet met derden.</p>
          </div>

          <div>
            <h2 className="font-display text-2xl font-medium text-brand-charcoal mb-2">Hoe lang bewaren we je gegevens?</h2>
            <p>We bewaren je gegevens zolang dat nodig is voor de goede werking van onze afsprakenwerking. Je kan steeds vragen om je gegevens in te kijken, te corrigeren of te laten verwijderen.</p>
          </div>

          <div>
            <h2 className="font-display text-2xl font-medium text-brand-charcoal mb-2">Beveiliging</h2>
            <p>Je gegevens worden veilig bewaard. De gegevens van klanten zijn enkel toegankelijk voor Nails Renss via een beveiligde beheeromgeving en zijn nooit publiek zichtbaar.</p>
          </div>

          <div>
            <h2 className="font-display text-2xl font-medium text-brand-charcoal mb-2">Contact</h2>
            <p>Heb je vragen over je gegevens? Contacteer ons telefonisch op 0465 00 03 31 of via Instagram @nails.renss.</p>
          </div>
        </div>
        <Link to="/boeken" className="inline-block mt-10 bg-brand-charcoal text-white font-semibold px-7 py-3.5 rounded-full hover:bg-brand-pinkhover transition-colors">
          BOEK JE AFSPRAAK
        </Link>
      </main>
      <Footer />
    </div>
  );
}
